import { colors } from "assets/styles/colors";
import { Grid } from "assets/styles/globalStyles";
import { FontSizes } from "utils/enums";
import styled from "styled-components";



export const HomepageWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content:center;
    flex-direction: column;
    height: 100vh;
    position:relative;
`

export const CenterText = styled.div<any>`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    max-width: 50vw;
    margin: 0 auto;
    color:#fff;
    position:relative;
    z-index:1;
    margin-top: 200px;
    direction:${(props) => props.direction};

    @media (max-width: 556px) {
        margin-top: 120px;
        max-width: 90vw;
    }

    ${(props) => props.direction === 'rtl' ?
        `
        p{
            font-size: 24px;
            text-align:center;
            @media (max-width: 556px) {
                font-size: 18px;
            }
        }
        h1{
            font-size:3.6rem;
            @media (max-width: 556px) {
                font-size:2rem;
                display: flex;
            }
        }
        ` :
        `
        p{
            font-size: 15px;
            text-align:center;
            @media (max-width: 556px) {
                font-size: 13px;
            }
        }
        h1{
            font-size:3rem;
            @media (max-width: 556px) {
                font-size: 1.6rem;
                display: flex;
            }
        }
        ` 
    }

    h1{
        
        text-align:center;
        font-weight: 700;
        color:#fff;

        svg{
            width: 60px;
            height: 60px;
            position: relative;
            top: -38px;
            left: 20px;
            fill:#fff;
            @media (max-width: 556px) {
                width: 36px;
                height: 36px;
                top: -28px;
            }
        }
    }

    p{
        text-align:center;
    }
`;

export const SearchInputWrapper = styled.div<any>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 70vw;
    margin: 0 auto;
    position: relative;
    z-index: 1;
    padding: 20px;
    background: #ffffff4f;
    border-radius: 10px;
    border: 1px solid #fff;
    margin: 50px 0;
    direction:${(props) => props.direction};
    @media (max-width: 556px) {
        margin: 80px 0;
    }
    ${(props) => props.direction === 'rtl' ?
        `input{
            font-size:20px;
        }
        button{
            
            right:auto;
            left:30px;
            font-size: 17px;
            @media (max-width: 556px) {
                top:120px;
                left:0;
            }
            
            
        }
        ` :
        `input{
            font-size: 14px;
            font-style: normal;
            font-weight: 200;
            letter-spacing: .01em;
        }
        button{
            left:auto;
            right:30px;
            font-size: 13px;
            @media (max-width: 556px) {
                top:120px;
                right:0;
            }
        }
        ` 
    }

    input{
        width:100%;
        padding:20px;
        background:none;
        border:none;
        outline:none;
        color:#fff;
        &::-webkit-input-placeholder {
            color: #fff;
          }
    }
    button{
            border: none;
            background: #ffffff;
            font-weight: 700;
            padding: 8px 20px;
            border-radius: 7px;
            display:flex;
            align-items:center;
            position:absolute;
            gap:5px;
            color:#000;
            svg{
                width: 25px;
                height: 25px;
                position: relative;
                fill: #000;
            }
            
    }
`;


